import styled from 'styled-components';
import Typography from '@material-ui/core/Typography';

export const TitleTypography = styled(Typography)`
  && {
    font-weight: ${({ theme }) => theme.typography.fontWeightBold};
  }
`;
